import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

// COMPONENTES
import { MoreComponent } from './more/more.component';
import { TurnosComponent } from './turnos/turnos.component';
import { PedidosComponent } from './pedidos/pedidos.component';
import { AyudaComponent } from './ayuda/ayuda.component';
import { AcercaDeComponent } from './acerca-de/acerca-de.component';
import { TiposDocumentosComponent } from './tipos-documentos/tipos-documentos.component';
import { TipoDocumentoComponent } from './tipo-documento/tipo-documento.component';
import { ObrasSocialesComponent } from './obras-sociales/obras-sociales.component';
import { ObraSocialComponent } from './obra-social/obra-social.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { UsuarioComponent } from './usuario/usuario.component';
import { MorePrestadoresComponent } from './more-prestadores/more-prestadores.component';
import { MorePrestadorComponent } from './more-prestador/more-prestador.component';
import { MoreComerciosComponent } from './more-comercios/more-comercios.component';
import { MoreComercioComponent } from './more-comercio/more-comercio.component';
import { EspecialidadesComponent } from './especialidades/especialidades.component';
import { MoreEspecialidadComponent } from './especialidad/especialidad.component';
import { PrestacionesComponent } from './prestaciones/prestaciones.component';
import { PrestacionComponent } from './prestacion/prestacion.component';
import { PerfilClienteComponent } from './perfil-cliente/perfil-cliente.component';
import { PerfilComercioComponent } from './perfil-comercio/perfil-comercio.component';
import { PerfilPrestadorComponent } from './perfil-prestador/perfil-prestador.component';
import { MoreNotificacionesComponent } from './notificaciones/notificaciones.component';
import { NgxMaskDirective } from 'ngx-mask';
import { MoreAdministradoresComponent } from './more-administradores/more-administradores.component';
import { MoreAdministradorComponent } from './more-administrador/more-administrador.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { ComunicacionesComponent } from './comunicaciones/comunicaciones.component';
import { ComunicacionComponent } from './comunicacion/comunicacion.component';
import { MoreOrdenesPrestadorComponent } from './more-ordenes-prestador/more-ordenes-prestador.component';
import { MoreOrdenesComercioComponent } from './more-ordenes-comercio/more-ordenes-comercio.component';
import { MoreOrdenPrestadorDetalleComponent } from './more-orden-prestador-detalle/more-orden-prestador-detalle.component';
import { MoreOrdenComercioDetalleComponent } from './more-orden-comercio-detalle/more-orden-comercio-detalle.component';


@NgModule({
  declarations: [
    MoreComponent,
    TurnosComponent,
    PedidosComponent,
    AyudaComponent,
    AcercaDeComponent,
    TiposDocumentosComponent,
    TipoDocumentoComponent,
    ObrasSocialesComponent,
    ObraSocialComponent,
    UsuariosComponent,
    UsuarioComponent,
    EspecialidadesComponent,
    MoreEspecialidadComponent,
    PrestacionesComponent,
    PrestacionComponent,
    PerfilClienteComponent,
    PerfilComercioComponent,
    PerfilPrestadorComponent,
    MoreNotificacionesComponent,
    MorePrestadoresComponent,
    MorePrestadorComponent,
    MoreComerciosComponent,
    MoreComercioComponent,
    MoreAdministradoresComponent,
    MoreAdministradorComponent,
    DeleteAccountComponent,
    ComunicacionesComponent,
    ComunicacionComponent,
    MoreOrdenesPrestadorComponent,
    MoreOrdenesComercioComponent,
    MoreOrdenPrestadorDetalleComponent,
    MoreOrdenComercioDetalleComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    NgxMaskDirective 
  ]
})
export class MoreModule { }
